import { createContext } from 'react'
import type { Key } from 'react'

export type TreadmillSelectionStore = {
  subscribe: (listener: () => void) => () => void
  isSelected: (rowKeyValue: Key) => boolean
  isDisabled: (record: unknown) => boolean | undefined
  toggle: (rowKeyValue: Key, checked: boolean) => void
}

export const TreadmillSelectionContext =
  createContext<TreadmillSelectionStore | null>(null)

export const createSelectionStore = (): TreadmillSelectionStore & {
  getKeys: () => ReadonlySet<Key>
  setKeys: (keys: ReadonlySet<Key>) => void
  setHandlers: (handlers: {
    isDisabled: (record: unknown) => boolean | undefined
    toggle: (rowKeyValue: Key, checked: boolean) => void
  }) => void
} => {
  const listeners = new Set<() => void>()
  let keys: ReadonlySet<Key> = new Set()
  let handlers = {
    isDisabled: (() => undefined) as (record: unknown) => boolean | undefined,
    toggle: (() => undefined) as (rowKeyValue: Key, checked: boolean) => void
  }

  return {
    subscribe: (listener) => {
      listeners.add(listener)

      return () => listeners.delete(listener)
    },
    isSelected: (rowKeyValue) => keys.has(rowKeyValue),
    isDisabled: (record) => handlers.isDisabled(record),
    toggle: (rowKeyValue, checked) => handlers.toggle(rowKeyValue, checked),
    setKeys: (nextKeys) => {
      keys = nextKeys
      listeners.forEach((listener) => listener())
    },
    getKeys: () => keys,
    setHandlers: (nextHandlers) => {
      handlers = nextHandlers
    }
  }
}
